<template>
  <div class="text-xs-center">
    <p class="title">
      Weiterleitung zu Calendly. Bitte warten Sie einen Moment …
    </p>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSDivider from '@/components/atoms/divider/CSDivider.vue'
import CSIcon from '@/components/atoms/icons/CSIcon.vue'

export default {
  name: 'CSEmailTracking',
  components: {
    CSDivider,
    CSButton,
    CSIcon,
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    city: {
      type: String,
      default: ''
    }
  },
  methods: {
    async recordUserClickToZapierAndRedirect()
    {
      //const uri = 'https://hooks.zapier.com/hooks/catch/913207/2ywqynd/' //Staging URL
      const uri = 'https://hooks.zapier.com/hooks/catch/913207/2ywlipz/' //Production URL
      const caregiverData = {
        Frontend_uuid__c: this.uuid,
      }
      console.log(caregiverData)
      try {
        await fetch(uri, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          body: JSON.stringify(caregiverData),
        })
      } catch (error) {
        throw new Error(error)
      }

    },
    constructUrlWithParams(caregiverCity) {
      if(caregiverCity === "Berlin" || caregiverCity === "berlin")
        return "https://calendly.com/bewerbung/telefonisches-kennenlernen";
      if(caregiverCity === "Hamburg" || caregiverCity === "hamburg")
        return "https://calendly.com/alltagshilfe-werden/telefonisches-kennenlern-gespraech";
      return "https://calendly.com/bewerbung/careship-ambulant-info-event-minijob-alltagshilfe";
    }
  },
  created() {
    this.recordUserClickToZapierAndRedirect().then(() => {
      const redirectUrl = this.constructUrlWithParams(this.city);
      window.location.href = redirectUrl;
    })
      .catch(error => {
        console.error('Error tracking user activity:', error);
        const redirectUrl = this.constructUrlWithParams(this.city);
        window.location.href = redirectUrl; // Proceed with redirection even if tracking fails
      });

  },
}
</script>
